import moment from 'moment';
/**
 * date 데이터 받아 YYYY-MM-DD 형식으로 리턴
 * @param param 
 * @returns String
 */
export function DateFormat(param){
    return moment(param).format('YYYY-MM-DD')
}